/**
 * Created by Dhanya Akhil on 1/30/2017.
 */
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from '../../shared/modules/shared.module';
import { HomeService } from '../home/services/home.service';
import { LoginComponent } from './components/login.component';
import { BsModalModule } from 'ng2-bs3-modal'
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive'; // this includes the core NgIdleModule but includes keepalive providers for easy wireup


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    RouterModule,
    BsModalModule,
    NgIdleKeepaliveModule.forRoot(),
    TranslateModule.forChild()
  ],
  declarations: [LoginComponent],
  //exports: [],
  providers: [HomeService]
})
export class LoginModule {
}
